// ── PeopleFilterPills — shared visual filter bar (controlled component) ─────
// Same vocabulary on Discover, BeeHive and BeeConnect — but each page owns its
// own state, so a filter on one page never empties another page.
// Pass `value` + `onChange` to wire to local state.

import { useApp } from '../contexts/AppContext';
import { useTr } from '../utils/useTr';

export default function PeopleFilterPills({ value, onChange, theme = 'dark', compact = false }) {
  const tr = useTr();
  const { lang } = useApp();
  const fr = lang === 'fr';

  const palette = theme === 'amber'
    ? { bgActive: 'rgba(201,168,76,0.18)', textActive: '#C9A84C',
        borderActive: 'rgba(201,168,76,0.6)', border: 'rgba(201,168,76,0.18)',
        text: 'rgba(196,176,128,0.85)' }
    : { bgActive: 'var(--gold)', textActive: 'var(--black)',
        borderActive: 'transparent', border: 'var(--border)',
        text: 'var(--muted)' };

  const FILTERS = [
    { id: 'all',        label: fr ? 'Tous'        : 'All' },
    { id: 'compatible', label: fr ? 'Compatibles' : 'Compatible' },
    { id: 'nearby',     label: fr ? 'À proximité' : 'Nearby' },
    { id: 'verified',   label: fr ? 'Vérifiés'    : 'Verified' },
    { id: 'friends',    label: fr ? 'Amitié'      : 'Friends' },
  ];

  return (
    <div style={{
      display: 'flex', gap: 6, overflowX: 'auto',
      padding: compact ? '0.4rem 1rem' : '0.6rem 1rem',
      scrollbarWidth: 'none', msOverflowStyle: 'none',
    }}>
      {FILTERS.map(f => {
        const active = (value || 'all') === f.id;
        return (
          <button
            key={f.id}
            onClick={() => onChange?.(f.id)}
            style={{
              flexShrink: 0,
              padding: compact ? '0.22rem 0.7rem' : '0.3rem 0.85rem',
              background: active ? palette.bgActive : 'transparent',
              border: `1px solid ${active ? palette.borderActive : palette.border}`,
              borderRadius: 99,
              color: active ? palette.textActive : palette.text,
              fontFamily: 'Outfit',
              fontSize: compact ? '0.62rem' : '0.7rem',
              fontWeight: active ? 600 : 400,
              letterSpacing: '0.02em',
              cursor: 'pointer',
              transition: 'all 0.15s',
              whiteSpace: 'nowrap',
            }}>
            {f.label}
          </button>
        );
      })}
    </div>
  );
}
